
import React from "react";
import ProductsOverview from "../components/products/ProductsOverview";
import Header from "../components/products/Header";


const Products = () => {

  return (
    <>
      <div>
        <Header  />
        <ProductsOverview />
      </div>
    </>
  );
};

export default Products;
